import { useSelector, TypedUseSelectorHook } from 'react-redux'

import type { RootState } from '../typedRedux/configureStoreWithHistory'

const useReduxSelector: TypedUseSelectorHook<RootState> = useSelector

export default useReduxSelector
